// A dedicated entry point for datadog. This way we can start tracking errors
// and logs as soon as possible (even before the app script starts executing).
import { DatadogService } from 'service/Common/DatadogService'
import { env } from 'util/env'

DatadogService.start(env)
